import User from 'records/User';

declare global {
  interface Window {
    aptrinsic(methodType, userData, accountData);
  }
}

export function initializeGainsightPX(user: User | null) {
  if (!user) {
    return;
  }

  if (!window.aptrinsic) {
    return console.error("Tried to initialize GainsightPX, but it isn't available yet");
  }

  window.aptrinsic(
    'identify',
    {
      email: user.email,
      id: user.id,
      firstName: user.firstName,
      lastName: user.lastName,
      isManager: user.role === 'manager',
      isAdmin: user.isAdmin(),
      isCoach: user.isCoach,
    },
    {
      id: user.accountId,
      name: user.accountName,
    }
  );
}
